import { useUpdateTask } from 'features/tasks';
import { useCallback } from 'react';
import { useUser } from 'shared/hooks/use-user';
import { Task } from 'shared/types/task';
import { TaskType } from 'shared/types/task-base';
import { Timeslot } from 'shared/types/timeslot';
import { Timestamp } from 'shared/types/timestamp';
import { getWeekStartsOn } from 'shared/utils/get-week-starts-on';
import { createPlannedOccurrenceForDate } from 'shared/utils/schedules';

export const useUpdateTimeslot = (representedDay: Timestamp) => {
  const { submit: updateTask } = useUpdateTask();
  const user = useUser();
  const weekStartsOn = getWeekStartsOn(user);

  return useCallback(
    (task: Task, timeslot: Timeslot | null) => {
      const _timeslot =
        timeslot?.startTime || timeslot?.duration ? timeslot : null;
      if (task.type === TaskType.Task) {
        updateTask({ id: task.id, timeslot: _timeslot });
        return;
      }

      // repeating/habit
      const schedules = task.schedules
        ? createPlannedOccurrenceForDate(task.schedules, representedDay, {
            timeslot: _timeslot,
            weekStartsOn,
            originalDate: representedDay,
          })
        : undefined;
      updateTask({ id: task.id, schedules });
    },
    [representedDay, updateTask, weekStartsOn],
  );
};
